<template>
  <fragment>
    <div class="page-content" @touchmove.prevent @mousewheel.prevent v-if="isShow">
      <img class="loadingBg-url" :src="info.loadingBgUrl" alt="">
      <img class="loading-url" :src="info.loadingUrl" alt="">
    </div>
  </fragment>
</template>

<script>
export default {
  name: "HomeBase",
  props: {
    info: {
      type: Object,
      required: true
    },
  },
  computed: {
    
  },
  data(){
    return {
      isShow: true
    }
  },
  mounted() {
    let timeout = this.info.laodingTime * 1000
    setTimeout(() => {
      this.isShow = false
    }, timeout);
  },

}
</script>

<style lang="scss" scoped>
.page-content {
  z-index: 1000;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  .loadingBg-url {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .loading-url {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    max-width: 100%;
  }
}
</style>